







































import { getBanner, BannerWithItems, BannerItem, deleteBannerItem } from '@/api/banner';
import { MessageBox } from 'element-ui';
import { Component, Vue, Watch } from 'vue-property-decorator';
import _get from 'lodash/get';

import ItemCreate from './item/Create.vue';

@Component({
  components: { ItemCreate },
})
export default class BannerDetail extends Vue {
  private banner?: BannerWithItems;
  private selectedItemIndex = 0;

  private modalVisible = false;
  private creating = false;

  get itemSelected() {
    const { selectedItemIndex: index, banner } = this;
    return Boolean(banner && 0 <= index && index < banner.items.length);
  }

  get selectedItem() {
    if (this.itemSelected) {
      return this.banner!.items[this.selectedItemIndex];
    }
    return undefined;
  }

  data() {
    return {
      banner: undefined,
    };
  }

  @Watch('banner')
  onBannerChange() {
    this.selectedItemIndex = 0;
    this.modalVisible = false;
  }

  @Watch('$route', { immediate: true })
  async onRouteChange(this: BannerDetail, route: typeof this['$route']) {
    const { bannerName } = route.query;
    if (typeof bannerName === 'string') {
      try {
        return (this.banner = await getBanner(bannerName));
      } catch (e) {
        this.$router.back();
        throw e;
      }
    }
    this.$router.back();
  }

  onCarouselChange(index: number) {
    this.selectedItemIndex = index;
  }

  async createItem() {
    this.creating = true;
    this.showModal();
  }

  async editItem() {
    if (this.itemSelected) {
      this.creating = false;
      this.showModal();
    }
  }

  async deleteItem() {
    if (!this.itemSelected) {
      return;
    }
    try {
      await MessageBox.confirm('是否确认删除选中的海报图？删除后无法恢复', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error',
      });
      await deleteBannerItem(this.banner!._id, this.selectedItem!._id);
      await this.onRouteChange(this.$route);
    } catch (error) {
      this.$message.error(_get(error, 'data.message') || error.message || '删除失败');
    }
  }

  async onItemCreated() {
    this.modalVisible = false;
    await this.onRouteChange(this.$route);
  }

  private showModal() {
    this.$nextTick(() => (this.modalVisible = true));
  }
}
